(() => {
  'use strict';
  const theme = window.SassyHiveTheme || {};
  const supportEmail = String(theme.supportEmail || 'queenbee@thesassyhive.com').trim() || 'queenbee@thesassyhive.com';
  const contactUrl = theme.contactUrl || '/#contact';

  const applyCatHomeDisclosure = () => {
    const sensitivityNotice = document.querySelector(
      '.quiz-step[data-step="5"] .sensitivity-guidance'
    );
    if (!sensitivityNotice || sensitivityNotice.dataset.catHomeDisclosure === 'true') return;

    sensitivityNotice.dataset.catHomeDisclosure = 'true';
    const disclosure = document.createElement('p');
    disclosure.className = 'cat-home-disclosure';
    disclosure.style.marginBottom = '0';
    disclosure.innerHTML = '<strong>🐾 Cat-friendly home:</strong> All items are prepared and packaged in a home with cats. We take care to keep cats away from merchandise and packing materials, but we cannot guarantee that an order will be completely free of pet hair or dander. Please consider this before ordering if you have a significant cat allergy.';
    sensitivityNotice.appendChild(disclosure);
  };

  const apply = () => {
    if (window.SassyHive?.config) {
      window.SassyHive.config.supportEmail = supportEmail;
      window.SassyHive.config.contactUrl = contactUrl;
    }

    document.querySelectorAll('a[href^="mailto:rnrhonda96@gmail.com"], a[href^="mailto:queenbee@thesassyhive.com"]')
      .forEach((link) => {
        link.href = `mailto:${supportEmail}`;
        if ((link.textContent || '').includes('@')) link.textContent = supportEmail;
      });

    const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      if (!/rnrhonda96@gmail\.com/i.test(node.nodeValue || '')) continue;
      node.nodeValue = node.nodeValue.replace(/rnrhonda96@gmail\.com/gi, supportEmail);
    }

    applyCatHomeDisclosure();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply, { once: true });
  else apply();
})();
